function initScroll() {

    $('.scroll-to').on('click', function(ev) {
        ev.preventDefault();

        var target = $(this).attr('href');

        disableScroll();
        $('html, body').stop().animate({
            scrollTop: $(target).offset().top - ($('.site-header').outerHeight() + 60)
        }, {
            duration: 800,
            complete: function() {
                enableScroll();
            }
        });
    });

}
